<section class="flex flex-col full-grow-no-shrink-no-basis" data-cy="qnr-add-condition">
  <div *ngIf="data.input.visibilityLogicGate" class="flex flex-row justify-start items-start auto-flex" data-cy="qnr-visibility-logic">
    <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
      <mat-label>Visibility Logic*</mat-label>
      <input matInput placeholder="Input" style="display: none" particleAnalytics
        analyticsCategory="choice-filter-modal-item-editor" analyticsAction="entity-scope-input">
      <mat-radio-group class="flex flex-col" [(ngModel)]="data.input.visibilityLogicGate.visibilityType"
        aria-label="Select an option" data-cy="qnr-visibility-logic-type">
        <mat-radio-button class="m-b-9" value="AlwaysVisible" data-cy="qnr-visibility-always-visible">Always Visible</mat-radio-button>
        <mat-radio-button *ngIf="isAllAlwaysHidden" class="m-b-9" value="AlwaysHidden" data-cy="qnr-visibility-always-hidden">Always Hidden</mat-radio-button>
        <mat-radio-button class="m-b-9" value="Conditional" data-cy="qnr-visibility-conditional">

          <div *ngIf="questions" class="when-contents flex flex-row justify-start items-center" data-cy="qnr-visibility-when-content">
            When
            <div *ngFor="let fieldLogicGate of fieldLogicGates; let i = index"
              class="flex flex-row justify-start items-center" [attr.data-cy]="'qnr-condition-row-' + i">
              <mat-form-field appearance="outline" class="non-border m-l-10">
                <mat-select (selectionChange)="onSelectedQuestionChange($event, i)"
                  [(ngModel)]="fieldLogicGate.defaultSelectedQuestion" placeholder="Select a field" [disabled]="false"
                  [attr.data-cy]="'qnr-condition-field-select-' + i">
                  <mat-option *ngFor="let question of questions" [value]="question">
                    {{question.questionId}}. {{question.title}}.
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="placeholder non-border m-l-10 ">
                <mat-select (selectionChange)="onDefaultSelectedOperatorChange($event, i)"
                  [(ngModel)]="fieldLogicGate.selectedOperator" placeholder="Select" [disabled]="false"
                  [attr.data-cy]="'qnr-condition-operator-select-' + i">
                  <mat-option *ngFor="let op of fieldLogicGate.applicableOperators" [value]="op">
                    {{op.displayText}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!--<mat-form-field *ngIf="selectedOperator.valueSelectionType==1" style="margin-bottom:0px!important"  class="no-placeholder-animation placeholder non-border m-l-5 m-b-0">
                <mat-select (selectionChange)="onSelectedAnswerChange($event)" [(ngModel)]="selectedSingleAnswer" placeholder="Select"
                            [disabled]="false"
                >
                  <mat-option *ngFor="let answer of answerDropDown" [value]="answer">
                    {{answer?.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field *ngIf="selectedOperator.valueSelectionType==2"  style="margin-bottom:0px!important"  class="no-placeholder-animation placeholder non-border m-l-5 m-b-0"  >
                <mat-select multiple [(ngModel)]="selectedMultipleAnswer" (selectionChange)="onSelectedAnswerChange($event)"
                            [disabled]="false" placeholder="Select"
                >
                  <mat-select-trigger>
                    {{(selectedMultipleAnswer &&selectedMultipleAnswer.length>0) ? selectedMultipleAnswer[0]?.text : ''}}
                    <span *ngIf="selectedMultipleAnswer?.length > 1" class="example-additional-selection">
        (+{{selectedMultipleAnswer.length - 1}} {{selectedMultipleAnswer?.length === 2 ? 'other' : 'others'}})
      </span>
                  </mat-select-trigger>
                  <mat-option *ngFor="let answer of answerDropDown" [value]="answer">
                    {{answer?.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>-->
              <particle-condition-editor-container *ngIf="fieldLogicGate.selectedOperator.operator !== 13"
                class=" m-l-10" [arguments]="fieldLogicGate.arguments"
                [dynamicFormControl]="fieldLogicGate.formCondition.valueFormControl"
                [fieldDefinition]="fieldLogicGate.fieldDefination" [multiSelect]="fieldLogicGate.isMultiCheck"
                [attr.data-cy]="'qnr-condition-value-' + i">
              </particle-condition-editor-container>

              <particle-condition-editor-container *ngIf="fieldLogicGate.isBetween" [arguments]="arguments"
                [dynamicFormControl]="formCondition.toValueFormControl"
                [fieldDefinition]="fieldLogicGate.fieldDefination" class="m-r-10 m-l-10"
                [attr.data-cy]="'qnr-condition-to-value-' + i">
              </particle-condition-editor-container>
            </div>
          </div>
        </mat-radio-button>
      </mat-radio-group>

    </mat-form-field>
  </div>

</section>